import {Expose} from 'class-transformer';

export class PlanningParameterItem {
    public readonly id!: string;

    @Expose({name: '@id'})
    public readonly iri!: string;
}
